import { useEffect } from 'preact/compat';
import useLocalStorageState from 'use-local-storage-state';
import useLocationDrawer from "@/hooks/useLocationDrawer";

export default function useRetailerAddress() {
	const toggleLocationDrawer = useLocationDrawer();
	const [ retailerObj, setRetailerObj ] = useLocalStorageState("dutchie_retailer");
	const retailerId = retailerObj?.id;
	const  location = dutchie.retailers.find(retailer => (retailer.id === retailerId) );

	useEffect(() => {
		if ( ! retailerId || ! location ) {
			return;
		}

		let addressDiv      = document.querySelectorAll('.cp-retailer-address');
		let retailerNameDiv = document.querySelectorAll('.cp-retailer-name');
		let retailerPhone   = document.querySelectorAll('.cp-retailer-phone');
		let retailerHours   = document.querySelectorAll('.cp-retailer-hours');
		let retailerLink    = document.querySelectorAll('.cp-retailer-link');
		let locationToggleBtn  = document.querySelectorAll('.cp-change-location');
		let retailerCity       = document.querySelectorAll('.cp-retailer-city');
		let retailerPicture    = document.querySelectorAll('picture.dynamic-location-image');
		let retailerImage      = document.querySelectorAll('picture.dynamic-location-image img, picture.dynamic-location-image source, img.dynamic-location-image');
		
		if ( retailerImage ) {
			retailerImage.forEach((item) => {
				item.setAttribute('src', location.image);
				item.setAttribute('srcset', location.imageSrcSet);
			});
		}
		if ( retailerPicture ) {
			retailerPicture.forEach((item) => {
				item.setAttribute('srcset', location.imageSrcSet);
			});
		}

		if ( retailerCity ) {
			retailerCity.forEach((item) => {
				item.textContent = location.city;
			});
		}
		
		if ( addressDiv ) {
			let format = `${location.line1} <br /> ${location.city}, ${location.state} ${location.zipCode}`;
  
			if (location.directionsURL) {
				format = `<a target="_blank" href="${location.directionsURL?.url}">${format}</a>`;
			}
			
			addressDiv.forEach((item) => {
				item.innerHTML = format;
			});
		}

		if ( retailerNameDiv ) {
			retailerNameDiv.forEach((item) => {
				item.innerHTML = location.name;
			});
		}

		if ( retailerPhone ) {
			retailerPhone.forEach((item) => {
				// Strip non-numeric characters from phone number check phone property is set
				let phone = location?.phone?.replace(/\D/g,'');
				item.innerHTML = `<a href="tel:${phone}">${location.phone}</a>`;
			});
		}

		if ( retailerHours ) {
			retailerHours.forEach((item) => {
				item.innerHTML = location.hours_static;
			});
		}

		if ( retailerLink ) {
			retailerLink.forEach((item) => {
				item.setAttribute('href', location.pageLink);
			});
		}

		if ( locationToggleBtn ) {
			locationToggleBtn.forEach((item) => {
				item.addEventListener('click', function() {
					toggleLocationDrawer();
				});
			});
		}
	}, [retailerId]);
}